import React from 'react';
import { Overlay } from './Overlay';
import { DialogWidget } from './DialogWidget';
import { DomEvent } from './DialogUtils';

interface SliderOptions {
  id: string;
  children?: React.ReactNode;
  layerActions?: DomEvent[];
  layerClassName: string;
  widgetClassName: string;
  showLayer?: boolean;
  layerStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  zIndex?: number;
}

export function Slider({
  children,
  layerActions,
  layerClassName,
  widgetClassName,
  id,
  zIndex,
  layerStyle,
  style,
  showLayer,
}: SliderOptions) {
  return (
    <>
      {showLayer && (
        <Overlay
          id={`${id}__overlay`}
          className={layerClassName}
          style={layerStyle}
          actions={layerActions}
          zIndex={zIndex ? zIndex : 0}
        />
      )}
      <DialogWidget id={`${id}__widget`} className={widgetClassName} style={style} zIndex={zIndex ? zIndex + 1 : 0}>
        {children}
      </DialogWidget>
    </>
  );
}
